class BerriInstagramMockup extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-ig-tab]');
    this.posts = this.querySelectorAll('[data-ig-post]');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.setActiveTab(tab));
    });

    this.gridScroll = this.querySelector('[data-ig-grid-scroll]');
    this.updateGridScroll();
    this.syncVisibleVideos();
  }

  updateGridScroll() {
    if (!this.gridScroll) return;

    const visiblePosts = [...this.posts].filter((post) => !post.classList.contains('is-hidden'));
    const needsScroll = visiblePosts.length > 9;

    this.gridScroll.classList.toggle('is-scrollable', needsScroll);
    if (!needsScroll) {
      this.gridScroll.scrollTop = 0;
    }
  }

  playVideo(video, post) {
    video.play().then(() => {
      post?.classList.add('is-playing');
    }).catch(() => {});
  }

  pauseVideo(video, post) {
    video.pause();
    post?.classList.remove('is-playing');
  }

  syncVisibleVideos() {
    this.posts.forEach((post) => {
      const video = post.querySelector('.berri-ig-testimonial__ig-post-video');
      if (!video) return;

      if (post.classList.contains('is-hidden')) {
        this.pauseVideo(video, post);
      } else {
        this.playVideo(video, post);
      }
    });
  }

  setActiveTab(activeTab) {
    const filter = activeTab.dataset.igTab;

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.posts.forEach((post) => {
      const type = post.dataset.mediaType || 'photo';
      const show = filter === 'all' || type === filter;
      post.classList.toggle('is-hidden', !show);
    });

    this.syncVisibleVideos();
    this.updateGridScroll();

    if (this.gridScroll) {
      this.gridScroll.scrollTop = 0;
    }
  }
}

class BerriIgVideo extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.container = this.querySelector('[data-ig-video-container]');
    this.video = this.querySelector('video');
    this.playBtn = this.querySelector('[data-ig-video-play]');

    if (!this.video) return;

    this.video.muted = true;
    this.video.setAttribute('muted', '');
    this.video.setAttribute('playsinline', '');

    this.playBtn?.addEventListener('click', (event) => this.togglePlayback(event));
    this.container?.addEventListener('click', (event) => {
      if (event.target.closest('[data-ig-video-play]')) return;
      this.togglePlayback(event);
    });

    this.video.addEventListener('play', () => this.syncPlayButton());
    this.video.addEventListener('pause', () => this.syncPlayButton());

    // Match berri-video-reviews: autoplay muted on load; play button stays hidden until user interacts
    this.playBtn?.classList.remove('is-visible');
    this.video.play().catch(() => {});
    this.syncPlayButton();
  }

  togglePlayback(event) {
    event?.preventDefault();
    event?.stopPropagation();

    this.playBtn?.classList.add('is-visible');

    if (this.video.paused) {
      this.video.play().catch(() => {});
    } else {
      this.video.pause();
    }
  }

  syncPlayButton() {
    if (!this.playBtn) return;

    const isPlaying = !this.video.paused && !this.video.ended;
    this.playBtn.classList.toggle('is-playing', isPlaying);
    this.playBtn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    this.playBtn.setAttribute(
      'aria-label',
      isPlaying ? 'Pause video' : this.playBtn.dataset.playLabel || 'Play video'
    );
  }
}

if (!customElements.get('berri-instagram-mockup')) {
  customElements.define('berri-instagram-mockup', BerriInstagramMockup);
}

if (!customElements.get('berri-ig-video')) {
  customElements.define('berri-ig-video', BerriIgVideo);
}
